import React, { useEffect, useState } from 'react';

import './Field.scss';

import TextField from './Fieldtypes/TextField';
import Checkbox from './Fieldtypes/Checkbox';
import Select from './Fieldtypes/Select';
import TextTitle from './Fieldtypes/TextTitle';
import TextNormal from './Fieldtypes/TextNormal';
import Divider from './Fieldtypes/Divider';
import Bool from './Fieldtypes/Bool';

const isEqual = require("react-fast-compare");

function Field(props: any) {
    const { type } = props;
    const [value, setValue] = useState(props.value);

    const handleFieldChange = (value: any) => {
        setValue(value);
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    useEffect(() => {

    }, []);

    const renderField = (type: any) => {
        switch (type) {
            case "divider":
                return (
                    <Divider></Divider>
                );

            case "bool":
                return (
                    <Bool
                        title={props.title}
                        value={value}
                        defaultValue={props.value}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        options={props.options}
                    ></Bool>
                );

            case "select":
                return (
                    <Select
                        title={props.title}
                        value={value}
                        defaultValue={props.defaultValue}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        options={props.options}
                        onKeyDown={props.onKeyDown}
                    ></Select>
                );

            case "input":
            case "password":
                return (
                    <TextField
                        title={props.title}
                        value={value}
                        defaultValue={props.defaultValue}
                        placeholderValue={props.placeholderValue}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                        onKeyDown={props.onKeyDown}
                        placeholder={props.placeholder}
                        type={type}
                        dataLpignore={props.dataLpignore}
                        autocomplete={props.autocomplete}
                    ></TextField>
                );

            case "checkbox":
                return (
                    <Checkbox
                        title={props.title}
                        value={value}
                        defaultValue={props.value}
                        disabled={props.disabled}
                        onChange={handleFieldChange}
                    ></Checkbox>
                );

            case "text_title":
                return (
                    <TextTitle
                        text={props.title}
                        options={props.options}
                    ></TextTitle>
                );

            case "text_normal":
                return (
                    <TextNormal
                        text={props.title}
                    ></TextNormal>
                );
        }
    }

    useEffect(() => {
        setValue(props.value);
    }, [props]);

    return (
        <div style={{ width: "100%" }} className={props.hidden == undefined || props.hidden == false ? "field" : "field hidden"} onClick={props.onClick}>
            { renderField(type)}
        </div>
    );
}

export default React.memo(Field, isEqual);